"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SavedIdViewState_1 = require("./SavedIdViewState");
/** Platform UI Components */
var Label_1 = require("@idp/ui-components/components/atoms/Label");
var Link_1 = require("@idp/ui-components/components/atoms/Link");
var Button_1 = require("@idp/ui-components/components/atoms/Button");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
// import { SavedIdViewCms } from './SavedIdView.cms';
// import { InlineErrorsCms } from '../../../common/CommonFunctions/InlineErrors.cms';
/** Stylesheets */
var globalStyles = require("../../../../styles/att-global.scss");
var loginStyles = require("../../../../styles/login-widget.scss");
var styles = require("./SavedIdView.scss");
/** LOB Components */
var Password_1 = require("../Password/Password");
var StandardView_1 = require("../StandardView/StandardView");
var RemoveSavedID_1 = require("./RemoveSavedID");
var PageLevelError_1 = require("../../../common/PageLevelError/PageLevelError");
/** Api, Reporting, Mappers, Request, Response */
var ReportingService_1 = require("../../../../api/ReportingService");
var Events_1 = require("../../../../api/Events");
var CommonFunctions_1 = require("../../../common/CommonFunctions/CommonFunctions");
var LoginApi_1 = require("../../../../api/LoginApi");
var AuthenticateAndLoginRequest_1 = require("../../../../models/request/AuthenticateAndLoginRequest");
var analytics_1 = require("@login/analytics");
var SavedIdView = /** @class */ (function (_super) {
    __extends(SavedIdView, _super);
    // private SavedIdViewCmsData: SavedIdViewCms;
    // private InlineErrorsCmsData: InlineErrorsCms;
    function SavedIdView(props) {
        var _this = _super.call(this, props) || this;
        _this.commonLoginSubmit = 'Common_Login_Submit';
        _this.passwordEntryIsValid = false;
        _this.commonFunctions = null;
        _this.savedUserIdHandler = null;
        _this.redirectUrl = 'https://www.att.com/shop/unified/authentication.html';
        _this.mvpView = true;
        _this.state = new SavedIdViewState_1.default();
        _this.api = new LoginApi_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        _this.initializeEvents();
        // this.checkForSavedUserId = this.checkForSavedUserId.bind(this);
        _this.saveIDSelectedHandler = _this.saveIDSelectedHandler.bind(_this);
        return _this;
    }
    SavedIdView.prototype.componentDidMount = function () {
        this.settingSaveIDList();
        // this.analyticsLoginPageLoad();
        this.events = new Events_1.default([SavedIdView.displayStandardViewEvent, StandardView_1.default.successEventName]);
    };
    SavedIdView.prototype.analyticsSaveIDViewFormPageLoad = function () {
        this.reportingService
            .analyticsLoginPageLoad('isLoginPageLoadedAlready', ReportingService_1.PageUrls.LOGIN_PAGE, ReportingService_1.PageName.LOGIN_PAGE);
    };
    SavedIdView.prototype.initializeEvents = function () {
        var _this = this;
        // this.SavedIdViewCmsData = CMS.get( new SavedIdViewCms(), 'SavedIdView' ).content;
        // this.InlineErrorsCmsData = CMS.get( new InlineErrorsCms(), 'InlineErrors' ).content;
        this.SavedIdViewCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        this.differentIDEvents = {
            onClick: function () {
                // fire Event to LoginWidget for StandardView Display
                _this.events.fireEvent({}, SavedIdView.displayStandardViewEvent);
            },
        };
        this.passwordPanelEvent = {
            passwordReady: function (isValdPassword, passwordValue, key) {
                _this.analyticsSaveIDViewFormPageLoad();
                _this.passwordEntryIsValid = isValdPassword;
                if (_this.passwordEntryIsValid) {
                    _this.setState({
                        isPasswordinValid: false,
                        passwordValue: passwordValue,
                        errormessagePasswordComponent: '',
                    }, function () {
                        if (key === 'Enter') {
                            _this.submitLogin();
                        }
                    });
                }
                else {
                    _this.setState({
                        isPasswordinValid: true,
                        errormessagePasswordComponent: '',
                    });
                }
            },
        };
        this.signInEvents = {
            onClick: function () {
                console.log('SavedIdView signInClicked', _this.state);
                var validationFlag = true;
                if (!_this.commonFunctions.notBlankCheck(_this.state.passwordValue)) {
                    validationFlag = false;
                    // console.log('Just password is blank');
                    _this.setState({
                        isPasswordinValid: true,
                        passwordErrorMessage: _this.SavedIdViewCmsData.error.invalidPasswordText,
                    });
                }
                if (!validationFlag) {
                    return;
                }
                // fire the event for backend call to LoginWidget
                if (!_this.state.disabled) {
                    _this.submitLogin();
                }
            },
        };
        this.removeIdClickEvent = {
            onClick: function () {
                console.log('removeIdClick');
                _this.reportingService.fireLinkClickEvent('Remove IDs', ReportingService_1.PageUrls.REMOVE_SAVED_ID_MODAL);
                _this.setState({
                    showRemoveSaveIdModal: true,
                });
            },
        };
        this.removeSavedIdEvents = {
            onClose: function (idsRemoved) {
                console.log("Closing savedId modal: " + idsRemoved);
                _this.setState({
                    showRemoveSaveIdModal: false,
                });
                if (idsRemoved) {
                    var idList = _this.props.data.savedUserIdHandler.getSavedUserIds();
                    console.log('updated list: ', idList);
                    if (idList.length === 0) {
                        _this.events.fireEvent({}, SavedIdView.displayStandardViewEvent);
                    }
                    else {
                        _this.setState({
                            displaySaveUserIDList: idList,
                            isUserIDSelected: false,
                            userID: '',
                        });
                    }
                }
            },
        };
    };
    SavedIdView.prototype.settingSaveIDList = function () {
        this.setState({
            displaySaveUserIDList: this.props.data.saveUserIDList,
        });
    };
    SavedIdView.prototype.saveIDSelectedHandler = function (id) {
        console.log('saveIDSelectedHandler ', id);
        this.analyticsSaveIDViewFormPageLoad();
        var saveUserIDList = this.props.data.saveUserIDList;
        this.setState({
            //  displaySaveUserIDList: saveUserIDList,
            isUserIDSelected: true,
            userID: id,
        });
        /* const updateSaveIDList = this.arrayRemove(this.props.data.saveUserIDList, id);
         this.setState( {
              displaySaveUserIDList: updateSaveIDList,
         });
       */
    };
    SavedIdView.prototype.arrayRemove = function (array, value) {
        return array.filter(function (el) { return el !== value; });
    };
    SavedIdView.prototype.userIDSelected = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: [styles.savedIdSelectedId].join(' ') },
                React.createElement(Label_1.default, { data: {
                        text: this.state.userID,
                    }, options: {
                        className: loginStyles.inputLabel,
                    }, testId: 'SavedID_Link_1' })),
            React.createElement(Password_1.default, { data: {
                    passwordErrorMessage: this.state.passwordErrorMessage,
                    showPasswordInvalidError: this.state.isPasswordinValid,
                    backendErrorMessage: this.state.errormessagePasswordComponent,
                }, events: this.passwordPanelEvent }),
            React.createElement("div", { id: "sumbitButton", className: [styles.ctaButtonGroup].join(' ') },
                React.createElement(Button_1.default, { data: {
                        // disabled:this.state.disabled,
                        text: this.state.disabled ?
                            this.SavedIdViewCmsData.common.buttonProcessingCTA :
                            this.SavedIdViewCmsData.common.buttonPrimarySignInCTA,
                    }, events: this.signInEvents, options: { size: ButtonProps_1.ButtonSize.LARGE, showLoader: this.state.disabled }, testId: 'LoginWidget_Button_SignIn' }))));
    };
    SavedIdView.prototype.render = function () {
        var _this = this;
        var listItems = this.state.displaySaveUserIDList.map(function (id) {
            var callclickHandler = {
                onClick: function () {
                    _this.saveIDSelectedHandler(id);
                },
            };
            if (_this.state.isUserIDSelected && id === _this.state.userID) {
                return (_this.userIDSelected());
            }
            else {
                return (React.createElement("li", { key: id },
                    React.createElement(Link_1.default, { data: {
                            content: id,
                        }, events: callclickHandler, testId: 'SavedID_Link_1' })));
            }
        });
        return (React.createElement("div", { className: [styles.savedIdSection].join(' ') },
            React.createElement("div", { className: [globalStyles.formRowMd].join(' ') },
                React.createElement("span", null, this.SavedIdViewCmsData.loginWidget.savedIdSubText)),
            this.state.errorMessage &&
                React.createElement("div", { className: [globalStyles.formRowSm, globalStyles.formRowBtmMd].join(' '), id: "error-focus" },
                    React.createElement(PageLevelError_1.default, { data: {
                            errorMessagePanel: 'SaveIdView',
                            errorMessageText: this.state.errorMessage,
                            errorMessageType: 'BACKEND_ERROR',
                        }, options: {
                            className: '',
                        }, testId: 'LoginWidget_ErrorMsg' })),
            React.createElement("div", { className: [styles.savedIdLinksSection].join(' ') },
                React.createElement("ul", null, listItems)),
            React.createElement("div", { className: [styles.differentRemoveIdSection].join(' ') },
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement(Link_1.default, { data: {
                                content: this.SavedIdViewCmsData.loginWidget.enterDifferentIdLinkText,
                            }, events: this.differentIDEvents, testId: 'SavedID_Enter_Different_ID' })),
                    React.createElement("li", null,
                        React.createElement(Link_1.default, { data: {
                                content: this.SavedIdViewCmsData.loginWidget.removeIdLinkText,
                            }, events: this.removeIdClickEvent, testId: 'SavedID_Remove_ID' })))),
            this.state.showRemoveSaveIdModal && (React.createElement(RemoveSavedID_1.default, { data: {
                    savedUserIdHandler: this.props.data.savedUserIdHandler,
                }, events: this.removeSavedIdEvents }))));
    };
    SavedIdView.prototype.submitLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validationFlag, retreiveUserInfo, request, result, exc_1, errorMessageCounter, uiErrorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // console.log('submitLogin !!');
                        this.analyticsSaveIDViewFormPageLoad();
                        validationFlag = true;
                        if (!this.commonFunctions.notBlankCheck(this.state.passwordValue)) {
                            validationFlag = false;
                            this.setState({
                                isPasswordinValid: true,
                                passwordErrorMessage: this.SavedIdViewCmsData.error.invalidPasswordText,
                            });
                        }
                        if (!validationFlag) {
                            return [2 /*return*/];
                        }
                        this.setState({
                            disabled: true,
                        });
                        retreiveUserInfo = false;
                        if (this.props.data.mvpView) {
                            retreiveUserInfo = true;
                        }
                        request = new AuthenticateAndLoginRequest_1.AuthenticateAndLoginRequest(this.state.userID, this.state.passwordValue, this.getReturnUrl(), retreiveUserInfo);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.authenticateAndLogin(request)];
                    case 2:
                        result = _a.sent();
                        console.log('authenticateAndLogin result:', JSON.stringify(result));
                        return [3 /*break*/, 4];
                    case 3:
                        exc_1 = _a.sent();
                        // console.log( 'authenticateAndLogin Failure', exc );
                        this.setState({ errorMessage: exc_1.message });
                        return [2 /*return*/];
                    case 4:
                        // This is outside the try block so that any errors in the
                        // setState or fireEvent don't get trapped by catch
                        if (result.error) {
                            console.log('authenticateAndLogin result.error :', result.error);
                            this.reportingService.fireLoginUIFormResponseEvent(true, result.error.message, result.error.errorId, analytics_1.ErrorTypeOption.Failure_User, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, ReportingService_1.PageUrls.LOGIN_PAGE, false);
                            errorMessageCounter = this.state.errorMessageCounter;
                            errorMessageCounter++;
                            uiErrorMessage = this.commonFunctions.invalidCredentailsCounter(result, errorMessageCounter, this.state.userID, this.getReturnUrl());
                            console.log('authenticateAndLogin result.error 2 : ', errorMessageCounter + ' ' + uiErrorMessage);
                            this.setState({
                                errorMessageCounter: errorMessageCounter,
                                errorMessage: uiErrorMessage,
                                errormessagePasswordComponent: uiErrorMessage,
                                disabled: false,
                            });
                            return [2 /*return*/];
                        }
                        else {
                            this.setState({ disabled: false });
                            this.handleSuccessResult(result);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SavedIdView.prototype.handleSuccessResult = function (result) {
        // If authenticated we are good to go
        if (result.content.authenticated) {
            // If not MVP View, send event, otherwise handle mvp
            if (!this.props.data.mvpView) {
                this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, ReportingService_1.PageUrls.LOGIN_PAGE, false);
                this.events.fireEvent({
                    authenticated: true,
                    cancelled: false,
                }, StandardView_1.default.successEventName);
            }
            else if (result.content.linkedWirelessAccNums &&
                (result.content.linkedWirelessAccNums.split(',').length === 1
                    && !result.content.passcodeAccountsSuppressed)) {
                this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, ReportingService_1.PageUrls.LOGIN_PAGE, false);
                this.events.fireEvent({
                    authenticated: true,
                    cancelled: false,
                }, StandardView_1.default.successEventName);
            }
            else {
                this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, this.redirectUrl, false);
                this.commonFunctions.gotoRedirect(this.redirectUrl);
            }
        }
        else {
            /** need redirect to old sales flow */
            this.reportingService.fireLoginUIFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Sign in', ReportingService_1.PageEventCode.LOGIN_PAGE, this.redirectUrl, false);
            if (result.content.invokeTguard) {
                // console.log( 'need to invoke tguard for intercept' );
                this.commonFunctions.invokeTguard(this.state.userID, this.state.passwordValue, false, this.savedUserIdHandler, this.getLoginUrl(), this.getReturnUrl());
            }
            else {
                // console.log( 'returned alternate destination - redirecting:', this.redirectUrl );
                this.commonFunctions.gotoRedirect(result.content.redirectUrl);
            }
        }
    };
    SavedIdView.prototype.getReturnUrl = function () {
        if (this.props.data && this.props.data.returnUrl) {
            return this.props.data.returnUrl;
        }
        else if (this.props.data && this.props.data.loginUrl) {
            return this.props.data.loginUrl;
        }
        else {
            var url = document.location.href +
                (document.location.href.indexOf('?') === -1 ? '?' : '&') +
                'authenticated=true';
            // return 'https://www.att.com/shop/unified/authentication.html';
        }
    };
    SavedIdView.prototype.getLoginUrl = function () {
        if (this.props.data && this.props.data.loginUrl) {
            return this.props.data.loginUrl;
        }
        else {
            return document.location.href;
        }
    };
    SavedIdView.displayStandardViewEvent = 'displayStandardViewEvent';
    return SavedIdView;
}(React.Component));
exports.default = SavedIdView;
//# sourceMappingURL=SavedIdView.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/SavedIdView.js
// module id = 586
// module chunks = 8